import {Component, Inject, OnInit} from '@angular/core';
import {BusinessContact} from '../../domain/business-contact';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import * as _ from 'lodash';
import {JwtDecoderService} from '../../../framework/services/jwt-decoder.service';

@Component({
    selector: 'app-business-contact-dialog',
    templateUrl: './business-contact-dialog.component.html',
    styleUrls: ['./business-contact-dialog.component.scss']
})
export class BusinessContactDialogComponent implements OnInit {

    public businessContacts: BusinessContact[];

    public formMode = false;

    public currentContact: BusinessContact;

    public errors = {};

    public formValid: boolean;

    public emailRequired = false;

    public showCertification = false;

    public isLogicheckUser = false;

    public certificationOptions: {
        display: string;
        value: string;
    }[];

    public validationConstraints = [
        {
            caseType: 'Common',
            field: 'zipCode',
            pattern: 'NOT_NULL',
            errorMessage: 'PLZ erforderlich'
        },
        {
            caseType: 'Common',
            field: 'zipCode',
            pattern: 'NOT_EMPTY',
            errorMessage: 'PLZ erforderlich'
        },
        {
            caseType: 'Common',
            field: 'zipCode',
            pattern: 'MIN_LENGTH',
            errorMessage: 'Ungültige PLZ',
            parameters: '5'
        },
        {
            caseType: 'Common',
            field: 'city',
            pattern: 'NOT_NULL',
            errorMessage: 'Ort erforderlich'
        },
        {
            caseType: 'Common',
            field: 'city',
            pattern: 'NOT_EMPTY',
            errorMessage: 'Ort erforderlich'
        },
        {
            caseType: 'Common',
            field: 'street',
            pattern: 'NOT_NULL',
            errorMessage: 'Anschrift erforderlich'
        },
        {
            caseType: 'Common',
            field: 'street',
            pattern: 'NOT_EMPTY',
            errorMessage: 'Anschrift erforderlich'
        },
        {
            caseType: 'Common',
            field: 'companyName',
            pattern: 'NOT_NULL',
            errorMessage: 'Name erforderlich'
        },
        {
            caseType: 'Common',
            field: 'companyName',
            pattern: 'NOT_EMPTY',
            errorMessage: 'Name erforderlich'
        },
        {
            caseType: 'Common',
            field: 'email',
            pattern: 'EMAIL',
            errorMessage: 'Ungültige Email-Adresse'
        }
    ];

    public zipCode: string;

    public warning: string;

    constructor(private dialogRef: MatDialogRef<BusinessContactDialogComponent>,
                @Inject(MAT_DIALOG_DATA) private data,
                private jwtHelper: JwtDecoderService) {
        this.dialogRef.disableClose = true;
    }

    ngOnInit() {
        this.businessContacts = this.data.businessContacts;
        this.emailRequired = this.data.emailRequired;
        this.zipCode = this.data.zipCode;
        this.showCertification = this.data.showCertification;
        this.certificationOptions = this.data.certificationOptions;
        this.isLogicheckUser = this.jwtHelper.hasRole('HORCH_USER_LOGICHECK');
    }

    cancel() {
        this.dialogRef.close();
    }

    selectBusinessContact(businessContact: BusinessContact) {
        /*if (this.emailRequired && !businessContact.email) {
            this.formMode = true;
            this.formValid = false;
            this.currentContact = businessContact;
            this.errors['email'] = 'Email-Adresse erforderlich';
        } else {*/
        this.dialogRef.close({businessContact: businessContact});
        // }

    }

    editBusinessContact(i: number) {
        this.formMode = true;
        this.formValid = true;
        this.currentContact = _.cloneDeep(this.businessContacts[i]);
        if (!this.currentContact.certification) {
            this.currentContact.certification = [];
        }
        if (this.showCertification && this.currentContact.certification.length === 0) {
            this.currentContact.certification.push('');
        }
    }

    addBusinessContact() {
        this.formMode = true;
        this.formValid = false;
        this.currentContact = {
            zipCode: this.zipCode,
            city: null,
            companyName: null, street: null, businessContactBlacklistCategories: [],
            email: null,
            blacklist: false
        };
        if (!this.currentContact.certification) {
            this.currentContact.certification = [];
        }
        if (this.showCertification && this.currentContact.certification.length === 0) {
            this.currentContact.certification.push('');
        }
    }

    cancelEdit() {
        this.formMode = false;
    }

    save() {
        this.validateForm();
        if (this.formValid) {
            this.dialogRef.close({businessContact: this.currentContact, edited: true});
        }
    }

    validateForm() {
        this.formValid = this.currentContact.zipCode && this.currentContact.zipCode.trim().length === 5 &&
            this.currentContact.city && this.currentContact.city.trim().length > 0 &&
            this.currentContact.street && this.currentContact.street.trim().length > 0 &&
            this.currentContact.companyName && this.currentContact.companyName.trim().length > 0 && this.validateEmail();


        /*if (this.emailRequired) {
            this.formValid = this.formValid && this.currentContact.email && this.currentContact.email.trim().length > 0;
        }*/
    }

    private validateEmail() {
        if (!this.currentContact.email) {
            return true;
        }
        const emailRegex = new RegExp('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,11}$');
        return emailRegex.test(this.currentContact.email.trim());
    }

    validateStreet() {
        if (!this.currentContact.id && this.currentContact.street) {
            const obj = _.find(this.businessContacts, ['street', this.currentContact.street]);
            this.warning = obj ? 'Achtung: Unter dieser Adresse ist schon ein Kontakt vorhanden' : null;
        }
    }

    deselectCertificates(noCertificates: boolean) {
        if (noCertificates) {
            this.currentContact.certification = [''];
        } else {
            this.currentContact.certification = this.currentContact.certification.filter(data => data !== '');
        }
    }
}
